export interface CategoryItem {
  key: string;
  url: string;
  icon: string;
}

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export const CATEGORIES: CategoryItem[] = [
  { key: 'shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { key: 'hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { key: 'tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { key: 'jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line' },
  { key: 'pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-scissors-line' },
  { key: 'headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-star-line' },
  { key: 'sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { key: 'underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { key: 'jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { key: 'accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-star-line' },
  { key: 'bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { key: 'belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { key: 'perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { key: 'other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];